import { AbstractControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  @Input() directory: string;

/* --------------------------------- Fields --------------------------------- */
  mediaList: File[] = [];
  @Input()
  type: string; // IMAGE, VIDEO, FILE
  @Input() fileInput: any;
  /* ------------------------------- constructor ------------------------------ */

  constructor(  private toast: ToastService,) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }


  // setFiles(fileList: FileList){
  //   for(let i=0; i < fileList.length; i++) {
  //     this.mediaList.push(fileList.item(i));
  //   }
  // }
  allowedImageTypes = ['image/png', 'image/jpeg', 'image/jpg'];

setFiles(fileList: FileList) {
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList.item(i);

    if (this.type === 'IMAGE') {

      if (!this.allowedImageTypes.includes(file.type)) {
        this.toast.openSnackBar("Only PNG, JPG, JPEG files are allowed");
        continue; 
      }
    }

    this.mediaList.push(file);
  }
}


  addFile(ev: any){
    if(this.fileInput?.value){
      this.fileInput?.value.push(ev);
    } else {
      this.fileInput?.setValue([ev]);
    }
  }

  removeUrl(i: number){
    this.fileInput.setValue(this.fileInput.value.filter((single:any, index: number)=> index !==i));
  }

}
